import { Environments } from '@/config';
import { NEBRASKA_PRODUCTION } from './nebraska.production';
import { NEBRASKA_STAGING } from './nebraska.staging';

export const NEBRASKA = import.meta.env.MODE === Environments.PROD ? NEBRASKA_PRODUCTION : NEBRASKA_STAGING;
